import { Navigate, useLocation } from "react-router-dom";
import { resolveLegacyStorefrontRedirect } from "../utils/legacyStorefrontRedirects";

function joinRedirect(target, search, hash) {
  if (!search) return `${target}${hash || ""}`;
  if (target.includes("?")) {
    return `${target}&${search.slice(1)}${hash || ""}`;
  }
  return `${target}${search}${hash || ""}`;
}

/**
 * Client-side mirror of Express 301s:
 * - legacy product-tag / price-band / renamed category paths
 * - trailing-slash normalize (/about → /about/)
 */
export default function TrailingSlashNormalizer() {
  const { pathname, search, hash } = useLocation();
  const legacyTarget = resolveLegacyStorefrontRedirect(pathname);
  if (legacyTarget) {
    return <Navigate to={joinRedirect(legacyTarget, search, hash)} replace />;
  }
  if (pathname !== "/" && !pathname.endsWith("/")) {
    return <Navigate to={`${pathname}/${search}${hash}`} replace />;
  }
  return null;
}
